// 冻结操作类型
export enum FreezeActionType {
  Freeze = 'freeze',
  Unfreeze = 'unfreeze',
}

// FreezeModal 组件 Props 接口
export interface FreezeModalProps {
  // 冻结操作类型
  freezeActionType: FreezeActionType
  // 是否显示弹窗
  visible: boolean
  // 关闭弹窗回调
  onClose: () => void
  // 冻结/解冻操作回调
  onFreezeAction: () => void
}